export default __webpack_public_path__ + "static/media/globe.710ac130.png";